'use strict';
import { Injectable } from '@angular/core';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { ReassignTestModalComponent } from '@ispm/layout/components/modals/reassign-test-modal/reassign-test-modal.component';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { IBulkOperationExecuter, IBulkOperationItem } from '../interfaces/bulk-operation.interface';

@Injectable()
export class BulkOperationReassignService implements IBulkOperationExecuter{
  constructor(private _userActionCreatorService: UserActionCreatorService,
              private _modalLoaderService: DynamicModalLoaderService,) {}

  beforeExecute(operationConfig: IBulkOperationItem, selectedTests, exceededTestsAmount, maxItemsCount: number): Observable<any> {
		let allowedRolesForReassignment: any;
		this._userActionCreatorService.getStoredOrganizationConfiguration()
      .take(1)
      .map((organization) => {
      allowedRolesForReassignment = organization.allowedRolesForReassignment ? organization.allowedRolesForReassignment : ['Pathologist'];
		}).toPromise();

		let modalPayload: any = {};
    modalPayload.bulkOperationMode = true;
    modalPayload.maxTests = operationConfig.maxItems;
    modalPayload.exceededTestsAmount = exceededTestsAmount;
    modalPayload.practitionerRoles = allowedRolesForReassignment;
    modalPayload.disallowedPractitionerRoles = ['Provider'];
		modalPayload.enableReassign = true;
		modalPayload.maxItemsCount = maxItemsCount;
		modalPayload.title = 'Reassign selected tests';
    modalPayload.modalName = 'ReassignTest';

		return this._modalLoaderService.popupModal(ReassignTestModalComponent,
		{
			content: modalPayload,
			backdropAllowed: false
		}, 
    ModalTypes.NONE).pipe(take(1), 
      switchMap(details => {
        if (details.payload){
          details.payload.targetPractitioner = details.payload.selectedPractId;
          delete details.payload.selectedPractId;
        }
        return of(details)
      })
    )
  }
}
